





























import { createComponent, ref } from "@vue/composition-api";
import { DumpAction } from "@megarax/client/src/dump";
import fileDownload from "js-file-download";
import csvStringify from "csv-stringify/lib/sync";

interface Props {
  dumpAction: DumpAction;
  defaultFileName: string;
}

export default createComponent<Props>({
  components: {},
  props: {
    dumpAction: { required: true },
    defaultFileName: { required: true },
  },
  setup(props, ctx) {
    const showDialog = ref(false);

    const formatOptions = [
      { name: "CSV", delimiter: ",", extension: "csv" },
      { name: "TSV", delimiter: "\t", extension: "tsv" },
      { name: "CSV(średniki)", delimiter: ";", extension: "csv" },
    ];

    const selectedFormat = ref(formatOptions[0]);
    const fileName = ref(props.defaultFileName);

    async function onConfirm() {
      const data = await props.dumpAction(true, selectedFormat.value.delimiter);

      const fullFileName =
        fileName.value + "." + selectedFormat.value.extension;
      fileDownload(data, fullFileName);
    }

    return { showDialog, onConfirm, formatOptions, selectedFormat };
  },
});
